(function ($, Drupal) {
  Drupal.behaviors.rotateElement = {
    attach: function attach(context) {
      $('#headingOne', context)
        .off()
        .on('click', () => {
          $('.rotate').toggleClass('down');
        });
    },
  };
}(jQuery, Drupal));
